import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ErrorIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1 12a11 11 0 1 1 22 0 11 11 0 0 1-22 0Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12 7c.6 0 1 .4 1 1v4a1 1 0 1 1-2 0V8c0-.6.4-1 1-1Zm-1 9c0-.6.4-1 1-1a1 1 0 1 1 0 2 1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default ErrorIcon;
